import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { localLangkeyArr } from "../../../assets/i18n";

@Injectable()
export class TranslateLoaderService implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getLocalLang(key): Observable<any> {
    const url = `./assets/i18n/${key}`;
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.get(url, httpOptions);
  }

  getTranslation(lang) {
    const initKey = localLangkeyArr.filter((key) =>
      key.split("/").reverse()[0].includes(lang),
    );
    const observerReq = [];
    initKey.forEach((key) => observerReq.push(this.getLocalLang(key)));
    return Observable.create(
      (observer) => {
        Observable.forkJoin(observerReq).subscribe(
          (resArr) => {
            let result = {};
            resArr.forEach((res) => {
              result = { ...result, ...res };
            });
            observer.next(result);
          },
          (err) => console.log(err),
        );
      },
      (err) => console.error("国际化文件初始化失败--失败原因", err),
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/common/translate/translateLoader.service.ts